import { CaretLeft, CaretRight } from '@phosphor-icons/react';

type AdminPaginationProps = {
  page: number;
  totalPages: number;
  t: any;
  onChange: (page: number) => void;
};

export default function AdminPagination({
  page,
  totalPages,
  t,
  onChange,
}: AdminPaginationProps) {
  return (
    <nav className="admin-pagination" aria-label={t.pagination}>
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        <CaretLeft />
        {t.previous}
      </button>
      <span>{t.page} <b>{page}</b> {t.of} {totalPages}</span>
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        {t.next}
        <CaretRight />
      </button>
    </nav>
  );
}
